export default "__VITE_ASSET__c6i8MvX6__"